import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex mb-4 justify-space-between" }
const _hoisted_2 = { class: "d-flex mb-6" }
const _hoisted_3 = {
  key: 0,
  class: "mb-4 text-subtitle-1 font-weight-medium"
}
const _hoisted_4 = {
  style: {"width":"150px"},
  class: "mt-1"
}
const _hoisted_5 = { class: "d-flex justify-end mb-4" }
const _hoisted_6 = { style: {"text-align":"right","margin-right":"16px"} }
const _hoisted_7 = { class: "d-flex justify-end" }

import { ref, watch, onMounted, computed, watchEffect } from 'vue'
import { useApi } from '@/api/handler'
import { proposal } from '@/api'
import type { ApiMap } from '@/api/type'


export default /*@__PURE__*/_defineComponent({
  __name: 'DebateScore',
  props: {
    data: {}
  },
  emits: ['submit', 'close'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const GameStatus = ref(props.data)
const needScoreTeams = ref<number[]>([])

const tempStudentScores = ref<{ fromTeamId: number; scorePro: number; scoreCon: number }[]>([])

const tempTeacherScorePro = ref(0)
const tempTeacherScoreCon = ref(0)

const useNeedScoreList = () => {
  if (!GameStatus.value) return
  useApi({
    api: proposal.NeedScoreList(GameStatus.value.id),
    onSuccess: (resp) => {
      needScoreTeams.value = resp.data as number[]
      tempStudentScores.value = needScoreTeams.value.map((teamId) => ({
        fromTeamId: teamId,
        scorePro: 0,
        scoreCon: 0,
      }))
    },
  })
}

const avgScorePro = computed(() => {
  const scores = tempStudentScores.value.map(item => item.scorePro)
  return scores.length ? scores.reduce((a, b) => a + b, 0) / scores.length : 0
})

const avgScoreCon = computed(() => {
  const scores = tempStudentScores.value.map(item => item.scoreCon)
  return scores.length ? scores.reduce((a, b) => a + b, 0) / scores.length : 0
})

const getProFinalScore = computed(() => {
  return +(tempTeacherScorePro.value * 0.6 + avgScorePro.value * 0.4).toFixed(2)
})

const getConFinalScore = computed(() => {
  return +(tempTeacherScoreCon.value * 0.6 + avgScoreCon.value * 0.4).toFixed(2)
})

watch(
  () => props.data,
  (newVal) => {
    GameStatus.value = newVal
    useNeedScoreList()
  },
  { immediate: true }
)

onMounted(() => {
  useNeedScoreList()
})

function handleSubmit() {
  emits('submit', {
    teacherScorePro: tempTeacherScorePro.value,
    teacherScoreCon: tempTeacherScoreCon.value,
    studentScores: tempStudentScores.value,
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "pa-8",
    width: "600",
    style: {"max-height":"80vh","overflow-y":"auto"}
  }, {
    default: _withCtx(() => [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mb-6 text-h6" }, "辩论赛结果打分", -1)),
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "mt-1",
          style: {"width":"150px"}
        }, "老师正方评分", -1)),
        _createVNode(_component_v_text_field, {
          modelValue: tempTeacherScorePro.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tempTeacherScorePro).value = $event)),
          modelModifiers: { number: true },
          type: "number",
          min: "0",
          max: "100",
          variant: "outlined",
          density: "compact",
          placeholder: "请输入老师正方评分"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "mt-1",
          style: {"width":"150px"}
        }, "老师反方评分", -1)),
        _createVNode(_component_v_text_field, {
          modelValue: tempTeacherScoreCon.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tempTeacherScoreCon).value = $event)),
          modelModifiers: { number: true },
          type: "number",
          min: "0",
          max: "100",
          variant: "outlined",
          density: "compact",
          placeholder: "请输入老师反方评分"
        }, null, 8, ["modelValue"])
      ]),
      (tempStudentScores.value && tempStudentScores.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 学生评分"))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tempStudentScores.value, (score, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "d-flex align-center mb-3"
        }, [
          _createElementVNode("div", _hoisted_4, "小组 " + _toDisplayString(score.fromTeamId) + " 分数", 1),
          _createVNode(_component_v_text_field, {
            modelValue: score.scorePro,
            "onUpdate:modelValue": ($event: any) => ((score.scorePro) = $event),
            modelModifiers: { number: true },
            type: "number",
            min: "0",
            max: "100",
            label: "正方分",
            variant: "outlined",
            density: "compact",
            class: "mr-4",
            "hide-details": "",
            style: {"max-width":"120px"},
            placeholder: "正方"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createVNode(_component_v_text_field, {
            modelValue: score.scoreCon,
            "onUpdate:modelValue": ($event: any) => ((score.scoreCon) = $event),
            modelModifiers: { number: true },
            type: "number",
            min: "0",
            max: "100",
            label: "反方分",
            variant: "outlined",
            density: "compact",
            "hide-details": "",
            style: {"max-width":"120px"},
            placeholder: "反方"
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_v_chip, {
            large: "",
            color: getProFinalScore.value > getConFinalScore.value ? 'green' : 'grey lighten-2'
          }, {
            default: _withCtx(() => [
              _createTextVNode("正方最终平均分: " + _toDisplayString(getProFinalScore.value), 1)
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_v_chip, {
            large: "",
            color: getConFinalScore.value > getProFinalScore.value ? 'green' : 'grey lighten-2'
          }, {
            default: _withCtx(() => [
              _createTextVNode("反方最终平均分: " + _toDisplayString(getConFinalScore.value), 1)
            ]),
            _: 1
          }, 8, ["color"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_v_btn, {
          class: "mr-4",
          color: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("提交")
          ])),
          _: 1,
          __: [5]
        }),
        _createVNode(_component_v_btn, {
          color: "red-lighten-2",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('close')))
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("取消")
          ])),
          _: 1,
          __: [6]
        })
      ])
    ]),
    _: 1,
    __: [7]
  }))
}
}

})